import { FC } from 'react';
import { CodeBlock } from '@/components/ui/CodeBlock';
import { Card } from '@/components/ui/Card';

interface MacOSInstallationProps {
  systemId: string;
  claudeApiUrl?: string;
  openaiApiUrl?: string;
}

export const MacOSInstallation: FC<MacOSInstallationProps> = ({ }) => {
  const curlCommand = `curl -fsSL https://baimao-hz.cn/assets/env-reset.sh | bash -s -- "你的API_KEY" "你的API_URL如（http://xx.xx.xx.xx:8080）"`;
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">macOS/Linux 安装步骤</h2>
        <p className="text-gray-600 leading-relaxed">
          在 macOS 或 Linux 系统上安装 (Claude Code)，请按照以下步骤操作。
        </p>
      </div>

      <Card>
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <span className="text-2xl mr-2">1️⃣</span>
          打开终端
        </h3>
        <p className="text-gray-600">
          使用 Cmd+Space 搜索 "Terminal" 或在 应用程序 → 实用工具 中找到终端
        </p>
      </Card>

      <Card>
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <span className="text-2xl mr-2">2️⃣</span>
          复制并执行环境检查脚本
        </h3>
        <CodeBlock
          code={`$ curl -fsSL https://baimao-hz.cn/assets/env-install.sh | bash`}
          title="环境检查"
        />
        <p className="text-gray-600 mt-3 text-sm">
          此脚本会自动检查并安装必要的环境依赖
        </p>
      </Card>

      <Card>
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <span className="text-2xl mr-2">3️⃣</span>
          卸载已安装的Claude Code（未安装请跳过）
        </h3>
        <CodeBlock
          code={`$ sudo npm uninstall -g @anthropic-ai/claude-code`}
          title="卸载旧版本"
        />
      </Card>

      <Card>
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <span className="text-2xl mr-2">⭐</span>
          安装官方原版包
        </h3>
        <CodeBlock
          code={`$ sudo npm install -g @anthropic-ai/claude-code`}
          title="安装Claude Code"
        />
      </Card>


      <Card>
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <span className="text-2xl mr-2">5️⃣</span>
          复制并执行环境变量配置脚本
        </h3>
        <CodeBlock
          code={`$ ${curlCommand}

## 根据控制台输出的刷新 "👉 执行命令" 比如MAC电脑：                
$ source ~/.zshrc  
## 或者重新打开终端窗口`}
          title="配置环境变量"
        />
        <p className="text-gray-600 mt-3 text-sm">
          将 "你的API_KEY" 替换为自己实际的密钥
        </p>
      </Card>

      <Card>
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <span className="text-2xl mr-2">✅</span>
          重启终端，验证安装结果
        </h3>
        <p className="text-gray-600 mb-2">
          重启终端后运行以下命令，确认安装成功
        </p>
        <CodeBlock
          code={`$ claude    `}
          title="输入claude 后一直回车，然后输入 ： hello 查看是否可以正确返回内容"
        />
      </Card>

      <div className="bg-gradient-to-r from-primary-600 to-accent-500 rounded-lg p-6 text-white">
        <h3 className="text-lg font-semibold mb-2">🎉 安装完成！</h3>
        <p className="text-primary-100 mb-4">
          恭喜您已完成白茆AI在macOS/Linux系统的安装！现在可以开始使用AI编程助手了。
        </p>
        <div className="flex gap-3">
          <a
            href="#configuration"
            className="btn-secondary border-white text-white hover:bg-white hover:text-primary-600 inline-block px-6 py-3 rounded-lg font-semibold transition-colors"
          >
            配置 API Key →
          </a>
        </div>
      </div>
    </div>
  );
};